import { useRef, useCallback } from 'react';

export const useTimeHelper = () => {
  const messageOrderRef = useRef(0);

  const incrementMessageOrder = useCallback(() => {
    messageOrderRef.current += 1;

    return messageOrderRef.current;
  }, []);

  const getOrderedTimestamp = useCallback(() => {
    const order = incrementMessageOrder();

    return new Date(Date.now() + order).toISOString();
  }, [incrementMessageOrder]);

  return { messageOrderRef, incrementMessageOrder, getOrderedTimestamp };
};
